interface PageSelectorProps {
  page: number;
  hasNext: boolean;
  onClickPrev: () => void;
  onClickNext: () => void;
  disabled?: boolean;
}

export function PageSelector({
  page,
  hasNext,
  onClickPrev,
  onClickNext,
  disabled = false,
}: PageSelectorProps) {
  return (
    <div className="flex items-center gap-3">
      <button
        type="button"
        onClick={onClickPrev}
        disabled={page === 1 || disabled}
        className="text-sm disabled:opacity-40 disabled:cursor-not-allowed transition-opacity"
      >
        ← Previous
      </button>
      <span className="text-sm text-[--ink-muted]">Page {page}</span>
      <button
        type="button"
        onClick={onClickNext}
        disabled={!hasNext || disabled}
        className="text-sm disabled:opacity-40 disabled:cursor-not-allowed transition-opacity"
      >
        Next →
      </button>
    </div>
  );
}
